<!-- dashboard.component.html -->
<div>
    <app-content-header [title]="'Dashboard'"></app-content-header>

    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-3 col-6">
                    <app-small-box
                        [title]="'New Orders'"
                        [text]="'150'"
                        [navigateTo]="'#'"
                        [variant]="'info'"
                        [icon]="{content: faCartShopping}"
                    ></app-small-box>
                </div>
                <div class="col-lg-3 col-6">
                    <app-small-box
                        [title]="'Bounce Rate'"
                        [text]="'53 %'"
                        [navigateTo]="'#'"
                        [variant]="'success'"
                        [icon]="{content: faChartSimple}"
                        [loading]="true"
                    ></app-small-box>
                </div>
                <div class="col-lg-3 col-6">
                    <app-small-box
                        [title]="'User Registrations'"
                        [text]="'44'"
                        [navigateTo]="'#'"
                        [variant]="'warning'"
                        [icon]="{content: faUserPlus}"
                        [loading]="'dark'"
                    ></app-small-box>
                </div>
                <div class="col-lg-3 col-6">
                    <app-small-box
                        [title]="'Unique Visitors'"
                        [text]="'65'"
                        [navigateTo]="'#'"
                        [variant]="'danger'"
                        [icon]="{content: faChartPie, variant: 'success'}"
                    ></app-small-box>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <app-info-box
                        [title]="'Messages'"
                        [text]="'1,410'"
                        [icon]="{content: faEnvelope, variant: 'info'}"
                    ></app-info-box>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <app-info-box
                        [title]="'Messages'"
                        [text]="'1,410'"
                        [variant]="'success'"
                        [icon]="{content: faEnvelope}"
                        [loading]="'dark'"
                    ></app-info-box>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <app-info-box
                        [title]="'Messages'"
                        [text]="'1,410'"
                        [variant]="'warning'"
                        [icon]="{content: faEnvelope}"
                    ></app-info-box>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <app-info-box
                        [title]="'Messages'"
                        [text]="'1,410'"
                        [variant]="'danger'"
                        [icon]="{content: faEnvelope}"
                    ></app-info-box>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <app-info-box
                        [title]="'Bookmarks'"
                        [text]="'41,410'"
                        [icon]="{content: faBookmark, variant: 'info'}"
                        [progressBar]="{
                            description: '70% Increase in 30 Days',
                            level: 70,
                            variant: 'success'
                        }"
                    ></app-info-box>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <app-info-box
                        [title]="'Bookmarks'"
                        [text]="'41,410'"
                        [variant]="'success'"
                        [icon]="{content: faBookmark}"
                        [progressBar]="{
                            description: '70% Increase in 30 Days',
                            level: 70,
                            variant: 'light'
                        }"
                    ></app-info-box>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <app-info-box
                        [title]="'Bookmarks'"
                        [text]="'41,410'"
                        [variant]="'warning'"
                        [icon]="{content: faBookmark}"
                        [loading]="true"
                        [progressBar]="{
                            description: '70% Increase in 30 Days',
                            level: 70,
                            variant: 'dark'
                        }"
                    ></app-info-box>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <app-info-box
                        [title]="'Bookmarks'"
                        [text]="'41,410'"
                        [variant]="'danger'"
                        [icon]="{content: faBookmark}"
                        [progressBar]="{
                            description: '70% Increase in 30 Days',
                            level: 70,
                            variant: 'light'
                        }"
                    ></app-info-box>
                </div>
            </div>
        </div>
    </section>
</div>
